import { Component, OnInit } from '@angular/core';
import { ReportTypes } from '../../enums/report-types';
import { ActivatedRoute } from '@angular/router';
import { UtilizationReportComponent } from './utilization-report/utilization-report.component';
import { PayrollReportComponent } from './payroll-report/payroll-report.component';
import { BillingReportComponent } from './billing-report/billing-report.component';
import { NgFor, NgIf, KeyValuePipe } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { REPORT } from 'src/app/constants/queryParamConstants';
import { BenchNotesReportComponent } from './bench-notes-report/bench-notes-report.component';

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss'],
    imports: [
        MatButtonToggleModule,
        ReactiveFormsModule,
        FormsModule,
        NgFor,
        NgIf,
        BillingReportComponent,
        PayrollReportComponent,
        UtilizationReportComponent,
        KeyValuePipe,
        BenchNotesReportComponent,
    ],
})
export class ReportsComponent implements OnInit {
    reportTypes = ReportTypes;
    selectedReport: string = ReportTypes.Billing;

    constructor(private route: ActivatedRoute) {}

    reportOrder = () => 0;

    ngOnInit(): void {
        const map = this.route.snapshot.queryParamMap;
        const report = map.get(REPORT);

        if (report) {
            this.selectedReport = report;
        }
    }
}
